/* eslint-disable @typescript-eslint/no-explicit-any */
import CustomModalWrapper from 'components/CustomModalWrapper/CustomModalWrapper';
import DetailTable from 'components/DetailTable';
import { ConfigItem } from 'components/DetailTable/types';
import LoadingScreen from 'components/LoadingScreen';
import React from 'react';
import { Row, Col } from 'reactstrap';

type Props = {
  data: any;
};

const FindingDetailModal = ({ data }: Props) => {
  if (!data || Object.keys(data).length === 0) return <LoadingScreen />;

  const findingDetailConfig: ConfigItem[] = [
    data.finding_id !== '' && data.finding_id !== null
      ? { name: 'Finding ID', key: 'finding_id', type: 'string' }
      : { name: 'ID', key: 'id', type: 'string' },
    // Hide endpoint, CA, sast
    data.source_type === 'was_data' && {
      name: 'Host Instance Vuln ID',
      key: 'host_instance_vuln_id',
      type: 'string',
    },
    // Hide sast
    data.source_type !== 'sast' && { name: 'QID', key: 'qid', type: 'string' },
    { name: 'Name', key: 'name', type: 'string' },
    // Hide CA, sast, was
    data.source_type === 'endpoint_data' && {
      name: 'Port',
      key: 'port',
      type: 'string',
    },

    { name: 'SSL', key: 'ssl', type: 'boolean' },

    // only for CA and EPs
    (data.source_type === 'endpoint_data' ||
      data.source_type === 'ca_data') && {
      name: 'FQDN',
      key: 'fqdn',
      type: 'string',
    },

    { name: 'Category', key: 'category', type: 'string' },
    // Hide endpoint, CA, sast
    data.source_type === 'was_data' && { name: 'URL', key: 'url', type: 'url' },
    // Hide endpoint, sast, was
    data.source_type === 'ca_data' && {
      name: 'Cloud Agent',
      key: 'cloud_agent_name',
      type: 'string',
    },
    { name: 'Issue Type', key: 'issue_type', type: 'string' },
    { name: 'Finding Type', key: 'finding_type', type: 'string' },
    { name: 'Severity', key: 'severity', type: 'number' },
    {
      name: 'Softwares',
      key: 'software_list',
      type: 'list',
      listConfig: {
        childNode: null,
        config: [
          { name: 'Name', key: 'product', type: 'string' },
          { name: 'Vendor', key: 'vendor', type: 'string' },
        ],
      },
    },
    {
      name: 'Vendor Reference',
      key: 'vendor_reference_list',
      type: 'listurl',
      listConfig: { childNode: 'id', config: [] },
    },
    // hide sast
    data.source_type !== 'sast' && {
      name: 'Threat',
      key: 'diagnosis',
      type: 'html',
    },
    // only sast
    data.source_type === 'sast' && {
      name: 'Estimated time to fix',
      key: 'effort',
      type: 'string',
    },
    { name: 'Impact', key: 'consequence', type: 'html' },
    // only sast
    data.source_type === 'sast' && {
      name: 'Fix',
      key: 'message',
      type: 'string',
    },
    { name: 'Solution', key: 'solution', type: 'html' },
    // hide sast, was
    data.source_type !== 'sast' &&
      data.source_type !== 'was_data' && {
        name: 'Results',
        key: 'results',
        type: 'html',
      },

    // only was
    ...(data.source_type === 'was_data'
      ? [
          { name: 'Parameters', key: 'param', type: 'string' },
          {
            name: 'Payloads',
            key: 'payload.list',
            type: 'list',
            listConfig: {
              childNode: 'PayloadInstance',
              config: [
                // { name: 'Payload', key: 'payload', type: 'string' },
                {
                  name: 'Request',
                  key: 'request',
                  type: 'object',
                  config: [
                    { name: 'Link', key: 'link', type: 'url' },
                    { name: 'Method', key: 'method', type: 'string' },
                    { name: 'Headers', key: 'headers', type: 'string' },
                  ],
                },
                { name: 'Response', key: 'response', type: 'string' },
              ],
            },
          },
        ]
      : []),
    // only was
    data.source_type === 'was_data' && {
      name: 'Access Path',
      key: 'access_path.list',
      type: 'list',
      listConfig: {
        childNode: 'Url',
        config: [{ name: 'URL Value', key: 'value', type: 'url' }],
      },
    },
    // only was
    data.source_type === 'was_data' && {
      name: 'OWASP',
      key: 'owasp.list',
      type: 'list',
      listConfig: {
        childNode: 'OWASP',
        config: [
          { name: 'Code', key: 'code', type: 'number' },
          { name: 'Name', key: 'name', type: 'string' },
          { name: 'URL', key: 'url', type: 'url' },
        ],
      },
    },
    // only was
    data.source_type === 'was_data' && {
      name: 'WASC',
      key: 'wasc.list',
      type: 'list',
      listConfig: {
        childNode: 'WASC',
        config: [
          { name: 'Code', key: 'code', type: 'number' },
          { name: 'Name', key: 'name', type: 'string' },
          { name: 'URL', key: 'url', type: 'url' },
        ],
      },
    },
    // hide sast
    data.source_type !== 'sast' && {
      name: 'CVSS',
      key: 'cvss',
      type: 'object',
      config: [
        { name: 'Base', key: 'base', type: 'string' },
        { name: 'Temporal', key: 'temporal', type: 'string' },
        { name: 'Vector String', key: 'vector_string', type: 'string' },
        {
          name: 'Access',
          key: 'access',
          type: 'object',
          config: [
            { name: 'Vector', key: 'vector', type: 'string' },
            { name: 'Complexity', key: 'complexity', type: 'string' },
          ],
        },
        {
          name: 'Impact',
          key: 'impact',
          type: 'object',
          config: [
            { name: 'Confidentiality', key: 'confidentiality', type: 'string' },
            { name: 'Integrity', key: 'integrity', type: 'string' },
            { name: 'Availability', key: 'availability', type: 'string' },
          ],
        },
        { name: 'Authentication', key: 'authentication', type: 'string' },
        { name: 'Exploitability', key: 'exploitability', type: 'string' },
        { name: 'Remediation Level', key: 'remediation_level', type: 'string' },
        { name: 'Report Confidence', key: 'report_confidence', type: 'string' },
      ],
    },
    // hide sast, was
    data.source_type !== 'sast' &&
      data.source_type !== 'was_data' && {
        name: 'CVSS V3',
        key: 'cvss_v3',
        type: 'object',
        config: [
          { name: 'Base', key: 'base', type: 'string' },
          { name: 'Temporal', key: 'temporal', type: 'string' },
          { name: 'Vector String', key: 'vector_string', type: 'string' },
          {
            name: 'Attack',
            key: 'attack',
            type: 'object',
            config: [
              { name: 'Vector', key: 'vector', type: 'string' },
              { name: 'Complexity', key: 'complexity', type: 'string' },
            ],
          },
          {
            name: 'Impact',
            key: 'impact',
            type: 'object',
            config: [
              {
                name: 'Confidentiality',
                key: 'confidentiality',
                type: 'string',
              },
              { name: 'Integrity', key: 'integrity', type: 'string' },
              { name: 'Availability', key: 'availability', type: 'string' },
            ],
          },
          {
            name: 'Privileges Required',
            key: 'privileges_required',
            type: 'string',
          },
          { name: 'User Interaction', key: 'user_interaction', type: 'string' },
          { name: 'Scope', key: 'scope', type: 'string' },
          {
            name: 'Exploit Code Maturity',
            key: 'exploit_code_maturity',
            type: 'string',
          },
          {
            name: 'Remediation Level',
            key: 'remediation_level',
            type: 'string',
          },
          {
            name: 'Report Confidence',
            key: 'report_confidence',
            type: 'string',
          },
        ],
      },
    {
      name: 'CVE LIST',
      key: 'cve_list',
      type: 'listurl',
      listConfig: { childNode: 'id', config: [] },
    },
    { name: 'Bugtraq List', key: 'bugtraq_list', type: 'array' },
    // only was
    data.source_type === 'was_data' && {
      name: 'CWE',
      key: 'cwe',
      type: 'listurl',
    },
    // only was
    data.source_type === 'was_data' && {
      name: 'Web App',
      key: 'web_app',
      type: 'object',
      config: [
        { name: 'ID', key: 'id', type: 'string' },
        { name: 'Name', key: 'name', type: 'string' },
        { name: 'URL', key: 'url', type: 'url' },
      ],
    },
    // only endpoint
    data.source_type === 'endpoint_data' && {
      name: 'Endpoint',
      key: 'endpoint_name',
      type: 'string',
    },
    // hide sast, was
    data.source_type !== 'sast' &&
      data.source_type !== 'was_data' && {
        name: 'Endpoint IP',
        key: 'endpoint_ip',
        type: 'string',
      },
    // on ca
    data.source_type === 'ca_data' && {
      name: 'Patchable',
      key: 'patchable',
      type: 'string',
    },
    { name: 'PCI Vulnerability', key: 'pci_flag', type: 'string' },
    { name: 'Status', key: 'status', type: 'string' },
    { name: 'Age', key: 'age', type: 'string' },
    { name: 'First Detected Date', key: 'first_detected_date', type: 'date' },
    { name: 'Last Detected Date', key: 'last_detected_date', type: 'date' },
    { name: 'Last Tested Date', key: 'last_tested_date', type: 'date' },

    data.first_reopened_datetime && {
      name: 'First Reopened Date',
      key: 'first_reopened_datetime',
      type: 'date',
    },
    data.last_reopened_datetime && {
      name: 'Last Reopened Date',
      key: 'last_reopened_datetime',
      type: 'date',
    },
    data.times_reopened && {
      name: 'Times Reopened',
      key: 'times_reopened',
      type: 'number',
    },
    data.last_fixed_datetime && {
      name: 'Last Fixed Date',
      key: 'last_fixed_datetime',
      type: 'date',
    },
    // hide sast
    {
      name: 'Ignored',
      key: 'ignore_message',
      type: 'html',
    },
  ].filter(
    (item) =>
      item !== null && item !== '' && item !== undefined && item !== false,
  );

  return (
    <CustomModalWrapper id="finding-scroll">
      <Row>
        <Col>
          <DetailTable data={data} config={findingDetailConfig} />
        </Col>
      </Row>
    </CustomModalWrapper>
  );
};

export default FindingDetailModal;
